import { motion } from "framer-motion"

const IconFullscreenEnter = ({ className, size = 32, fill = "currentColor", ...animations }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <motion.path
      {...animations}
      d="M6 14v4h4v2H4v-6h2Zm14 0v6h-6v-2h4v-4h2ZM10 4v2H6v4H4V4h6Zm10 0v6h-2V6h-4V4h6Z"
      fill={fill}
      stoke="none"
      fillRule="evenodd"
    />
  </svg>
)

export default IconFullscreenEnter
